"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.COUPON_TICKET_CARD_DEFAULTS = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const COUPON_TICKET_CARD_DEFAULTS = exports.COUPON_TICKET_CARD_DEFAULTS = {
  applyText: 'APPLY',
  removeText: 'REMOVE',
  railWidth: 62.541,
  minHeight: 163,
  discountFontSize: 26,
  discountFontSizeCompact: 20,
  discountCompactLength: 9,
  borderRadius: 16,
  fontFamily: 'Inter, sans-serif',
  displayFontFamily: '"Bricolage Grotesque", Inter, sans-serif',
  colors: {
    surface: '#ffffff',
    border: '#f5f2ff',
    divider: '#f2f2f3',
    code: '#100e15',
    text: '#686670',
    discount: 'var(--primary-button, #714fff)',
    apply: 'var(--primary-button, #714fff)',
    remove: '#ef4444',
    railStart: '#ddd4ff',
    railMid: '#ffffff',
    railShadow: 'rgba(207, 200, 255, 0.6)'
  }
};

// Scalloped right edge of the stub — a 3.5px notch every 10px, punched out with a mask.
const NOTCH_RADIUS = 3.5;
const NOTCH_SPACING = 10;
const notchMask = `radial-gradient(circle ${NOTCH_RADIUS}px at 100% ${NOTCH_SPACING / 2}px, transparent ${NOTCH_RADIUS}px, #000 ${NOTCH_RADIUS + 0.1}px)`;
const CouponTicketCard = _ref => {
  let {
    code,
    discountLabel,
    description,
    details,
    applied = false,
    disabled = false,
    loading = false,
    onApply,
    onRemove,
    applyText = COUPON_TICKET_CARD_DEFAULTS.applyText,
    removeText = COUPON_TICKET_CARD_DEFAULTS.removeText,
    railWidth = COUPON_TICKET_CARD_DEFAULTS.railWidth,
    minHeight = COUPON_TICKET_CARD_DEFAULTS.minHeight,
    discountFontSize,
    borderRadius = COUPON_TICKET_CARD_DEFAULTS.borderRadius,
    fontFamily = COUPON_TICKET_CARD_DEFAULTS.fontFamily,
    displayFontFamily = COUPON_TICKET_CARD_DEFAULTS.displayFontFamily,
    colors: colorsProp,
    sx = {},
    ...rest
  } = _ref;
  const colors = {
    ...COUPON_TICKET_CARD_DEFAULTS.colors,
    ...colorsProp
  };
  const actionDisabled = disabled || loading;
  const railFontSize = discountFontSize ?? (String(discountLabel ?? '').length > COUPON_TICKET_CARD_DEFAULTS.discountCompactLength ? COUPON_TICKET_CARD_DEFAULTS.discountFontSizeCompact : COUPON_TICKET_CARD_DEFAULTS.discountFontSize);
  const handleAction = e => {
    if (actionDisabled) return;
    e.stopPropagation();
    if (applied) onRemove?.(code);else onApply?.(code);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
    sx: {
      display: 'flex',
      alignItems: 'stretch',
      minHeight: `${minHeight}px`,
      width: '100%',
      boxSizing: 'border-box',
      borderRadius: `${borderRadius}px`,
      border: `1px solid ${colors.border}`,
      background: colors.surface,
      boxShadow: '0px 24px 11px -21px rgba(0, 0, 0, 0.06)',
      overflow: 'hidden',
      opacity: disabled ? 0.6 : 1,
      fontFamily,
      ...sx
    },
    ...rest,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
      sx: {
        flexShrink: 0,
        width: `${railWidth}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(138deg, ${colors.railStart} 0%, ${colors.railMid} 52%, ${colors.railStart} 100%)`,
        boxShadow: `inset -3px 0 3px ${colors.railShadow}`,
        maskImage: notchMask,
        maskSize: `100% ${NOTCH_SPACING}px`,
        maskRepeat: 'repeat-y',
        WebkitMaskImage: notchMask,
        WebkitMaskSize: `100% ${NOTCH_SPACING}px`,
        WebkitMaskRepeat: 'repeat-y'
      },
      children: discountLabel && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
        sx: {
          transform: 'rotate(-90deg)',
          whiteSpace: 'nowrap',
          fontFamily: displayFontFamily,
          fontWeight: 700,
          fontSize: `${railFontSize}px`,
          lineHeight: 1.3,
          textTransform: 'uppercase',
          color: colors.discount,
          m: 0
        },
        children: discountLabel
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      sx: {
        display: 'flex',
        flex: '1 0 0',
        minWidth: 0,
        flexDirection: 'column',
        gap: '12px',
        p: '16px',
        background: colors.surface
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
        sx: {
          display: 'flex',
          flexDirection: 'column',
          gap: '8px'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
          sx: {
            display: 'flex',
            gap: '12px',
            alignItems: 'flex-start'
          },
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
            sx: {
              flex: '1 0 0',
              minWidth: 0,
              fontFamily: displayFontFamily,
              fontWeight: 600,
              fontSize: '16px',
              lineHeight: 1.3,
              textTransform: 'uppercase',
              wordBreak: 'break-word',
              color: colors.code,
              m: 0
            },
            children: code
          }), (onApply || onRemove) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.ButtonBase, {
            disableRipple: true,
            disabled: actionDisabled,
            onClick: handleAction,
            sx: {
              flexShrink: 0,
              minWidth: '39px',
              justifyContent: 'flex-end'
            },
            children: loading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
              size: 14,
              sx: {
                color: applied ? colors.remove : colors.apply
              }
            }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
              sx: {
                fontFamily,
                fontWeight: 600,
                fontSize: '12px',
                lineHeight: 1.6,
                whiteSpace: 'nowrap',
                color: applied ? colors.remove : colors.apply,
                m: 0
              },
              children: applied ? removeText : applyText
            })
          })]
        }), description && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 500,
            fontSize: '12px',
            lineHeight: 1.3,
            color: colors.text,
            m: 0
          },
          children: description
        })]
      }), details && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Box, {
          sx: {
            height: 0,
            borderTop: `1px solid ${colors.divider}`
          }
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Typography, {
          sx: {
            fontFamily,
            fontWeight: 500,
            fontSize: '11px',
            lineHeight: 1.5,
            color: colors.text,
            m: 0
          },
          children: details
        })]
      })]
    })]
  });
};
var _default = exports.default = CouponTicketCard;